export default __webpack_public_path__ + "static/media/uruguay.6bcd7935.webp";